import { Box, Stack, Typography, useTheme, AccordionSummary } from "@mui/material";
import { truncateString } from "helpers/stringHelper";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  StyledAccordion,
  StyledAccordionSummary,
  LessonNameBox,
  UnderlinedTypography,
  PercentageBox,
  StyledLinearProgress,
  PointsBox
} from "./SimpleLessonComponent.styles";

export const SimpleLessonComponent = ({ lessonName, maxPoints, index }: { lessonName: string, maxPoints: number, index: number }) => {
    const theme = useTheme();
    const { t } = useTranslation();
  
    return (
        <StyledAccordion key={index} expanded={false}>
            <StyledAccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
            >
                <Stack direction={'row'} width={'100%'} display={'flex'} justifyContent={'space-between'} paddingLeft={theme.spacing(2)} alignItems={'center'}>
                    <LessonNameBox>
                    <UnderlinedTypography>{truncateString(lessonName, 25)}</UnderlinedTypography>
                    </LessonNameBox>
                    <PercentageBox sx={{ paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2) }}>
                    <Typography>{'0 %'}</Typography>
                    </PercentageBox> 
                    <StyledLinearProgress variant="determinate" value={0} />
                    <PointsBox>
                    <Typography>{`${0} / ${maxPoints}`}</Typography>
                    </PointsBox>
                </Stack>
            </StyledAccordionSummary>
        </StyledAccordion>
    );
  }